module.exports = __webpack_public_path__ + "static/home_high-8099c952d57a7aaac9f3c42a3b51115f.mp4";